<div class="process-widget twc-card twc-m-2" [ngClass]="{'twc-loader-container': isLoading}">
    <header class="twc-card-header">
        <h4 class="twc-card-title cursor-pointer" (click)="navigateToJobs()">{{'NAVBAR.JOBS' | translate}}</h4>
    </header>
    <div class="twc-card-content twc-p-0">
        <table class="twc-table twc-table-striped twc-mb-0 process-widget-table"
            attr.aria-describedby="{{'JOBS.WIDGET_TABLE_DESCRIPTION' | translate}}">
            <thead>
                <tr>
                    <th class="date-column"></th> <!-- Date column -->
                    <th></th> <!-- Type column -->
                    <th></th> <!-- Project column -->
                    <th class="status-column"></th> <!-- Status column -->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let process of processList">
                    <td> {{ process.createdAt | localizedDate}} </td>
                    <td> {{ 'JOBS.PROCESS_TYPE.' + process.type | translate}} </td>
                    <td> {{ process.parentEntity?.name}} </td>
                    <td class="status-badge">
                        <twc-badge class="width-100" [type]="getStatusBadgeType(process)">
                            {{ 'JOBS.' + process.status | translate}}
                        </twc-badge>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="twc-loader-overlay" *ngIf="isLoading">
        <twc-loader size="large"></twc-loader>
    </div>
</div>